export const MOBILE_BREAKPOINT = 992;
export const DESKTOP_BREAKPOINT = 1025;
